import {
  FeedstockBmpPotentialElemental,
  FeedstockBmpPotentialElementalPropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-elemental.model';
import { ValidationInterface } from '../../../validation.interface';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialElementalValidation implements ValidationInterface {
  /** The current BMP potential elemental obj that is being validated */
  bmpPotentialElemental: FeedstockBmpPotentialElemental;

  /**
   * Sets the BMP potential elemental obj that will be used for validation
   * @param bmpPotentialElemental will be used to set the current BMP potential elemental obj
   */
  constructor(bmpPotentialElemental: FeedstockBmpPotentialElemental) {
    if (!bmpPotentialElemental) throw Error('invalid BMP potential elemental provided for validation');
    this.bmpPotentialElemental = new FeedstockBmpPotentialElemental(bmpPotentialElemental);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential elemental obj
   * @param validationUnit, if provided will have the validation for the current BMP potential elemental
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialElemental) throw Error('unable to validate BMP potential elemental');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.c).getValidation(),
      FeedstockBmpPotentialElementalPropName.c
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.h).getValidation(),
      FeedstockBmpPotentialElementalPropName.h
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.n).getValidation(),
      FeedstockBmpPotentialElementalPropName.n
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.s).getValidation(),
      FeedstockBmpPotentialElementalPropName.s
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.o).getValidation(),
      FeedstockBmpPotentialElementalPropName.o
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialElemental.biodegradability).getValidation(),
      FeedstockBmpPotentialElementalPropName.biodegradability
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential elemental obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
